import React from "react";
import * as MUI from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { CRIMSON_RED } from "../../../../enums/Colors";
import ConfirmAndCancelButtons from "../../../../components/buttons/ConfirmAndCancelButtons";
import { useFormDeleteNoConfirm } from "../../../../hooks/useFormDelete";
import * as apiPaths from "../../../../enums/ApiPaths";
import { INSTITUTIONS_LIST } from "../../../../enums/QueryKeys";
import { useQueryClient } from "@tanstack/react-query";
import logger from "../../../../utils/logger";

export default function DeleteInstitutionDialog({ institution, clinicId, onCancel, onDeleted }) {
  const { t } = useTranslation();
  const deletion = useFormDeleteNoConfirm(apiPaths.INSTITUTION, institution?.id, null, 0);
  const queryClient = useQueryClient();

  async function onConfirm() {
    try {
      await deletion.submitForm();
      queryClient.invalidateQueries({ queryKey: [INSTITUTIONS_LIST + clinicId] });
      onCancel();
      onDeleted?.(institution);
    } catch (err) {
      logger.error("Failed to delete institution", err);
    }
  }

  return (
    <MUI.Dialog
      open={Boolean(institution)}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <MUI.Stack direction="row" justifyContent="flex-end" sx={{ p: 1 }}>
        <MUI.IconButton onClick={onCancel} size="small">
          <CloseIcon fontSize="small" />
        </MUI.IconButton>
      </MUI.Stack>
      <MUI.Stack pt={0} justifyContent="center" alignItems="center">
        <MUI.Avatar
          sx={{ bgcolor: MUI.alpha(CRIMSON_RED, 0.12), width: 64, height: 64 }}
        >
          <WarningAmberOutlinedIcon
            htmlColor={CRIMSON_RED}
            sx={{ fontSize: 34 }}
          />
        </MUI.Avatar>
      </MUI.Stack>
      <MUI.DialogTitle sx={{ textAlign: "center", fontWeight: 700 }}>
        {t("Delete")} {institution?.name}
      </MUI.DialogTitle>
      <MUI.DialogContent sx={{ textAlign: "center" }}>
        <MUI.Typography color="text.secondary">
          {t("ReallyWantDeleteInstitution")}
        </MUI.Typography>
      </MUI.DialogContent>
      <MUI.DialogActions sx={{ p: 2, pt: 0 }}>
        <ConfirmAndCancelButtons
          confirmTitle="Delete"
          cancelTitle=""
          onConfirm={onConfirm}
          isConfirmLoading={deletion.loading}
          confirmButtonProps={{ color: "error" }}
        />
      </MUI.DialogActions>
    </MUI.Dialog>
  );
}
